import React, { useEffect } from "react";
import styled from "styled-components";
import {
  Switch,
  Route,
  useRouteMatch,
  useParams,
  Redirect,
} from "react-router-dom";
import Context from "../../context";
import Berita from "./Berita";
import Kegiatan from "./Kegiatan";
import Loker from "./Loker";
import Lain from "./Lain";
// import VideoYoutube from "./VideoYoutube";
import {
  Banner,
  CardSubMenu,
  Gap,
  // BeritaTerbaru,
  // Card,
} from "../../components";

const StyledBody = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 40px;
  margin: 0 16px;
  padding-bottom: 32px;
  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
`;

const StyledSidebar = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  @media screen and (max-width: 500px) {
    width: 100%;
  }
`;

const StyledBorder = styled.div`
  border-left: 1px solid #d4d4d4;
  margin: 0 40px;
  @media screen and (max-width: 800px) {
    margin-left: 16px;
    margin-right: 32px;
  }
  @media screen and (max-width: 500px) {
    display: none;
  }
`;

const StyledContent = styled.div`
  width: 100%;
  max-width: 750px;
  flex: 1;
  padding-top: 16px;
  @media screen and (max-width: 500px) {
    padding-top: 32px;
  }
`;

const DataRuangBerita = [
  {
    title: "Berita",
    titleEn: "News",
    subUrl: "/berita",
  },
  {
    title: "Kegiatan",
    titleEn: "Activities",
    subUrl: "/kegiatan",
  },
  // {
  //   title: "Video Youtube",
  //   titleEn: "Youtube Videos",
  //   subUrl: "/video-youtube",
  // },
];

const DataPengumuman = [
  {
    title: "Lowongan Pekerjaan",
    titleEn: "Job Vacancy",
    subUrl: "/loker",
  },
  {
    title: "Pengumuman Lainnya",
    titleEn: "More Announcements",
    subUrl: "/lain",
  },
];

const PusatMediaSub = ({ isId }: { isId: boolean }) => {
  const { pusatMediaId }: any = useParams();

  if (pusatMediaId === "berita") return <Berita isId={isId} />;
  if (pusatMediaId === "kegiatan") return <Kegiatan isId={isId} />;
  if (pusatMediaId === "loker") return <Loker isId={isId} />;
  if (pusatMediaId === "lain") return <Lain isId={isId} />;
  return <>Not Found</>;
};

const PusatMedia = () => {
  const { path, url } = useRouteMatch();
  const context = React.useContext(Context);
  const currentLang = context.getLang();
  const isId = currentLang === "ID";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Banner title={isId ? "Ruang Berita" : "News Room"} />
      <StyledBody>
        <StyledSidebar>
          <CardSubMenu
            title={isId ? "Ruang Berita" : "News Room"}
            url={url}
            isId={isId}
            data={DataRuangBerita}
          />
          <Gap height={2.28} />
          <CardSubMenu
            title={isId ? "Pengumuman" : "Announcements"}
            url={url}
            isId={isId}
            data={DataPengumuman}
          />
        </StyledSidebar>
        <StyledBorder />
        <StyledContent>
          <Switch>
            <Route exact path={path}>
              <Redirect to={`${path}/berita`} />
            </Route>
            <Route path={`${path}/:pusatMediaId`}>
              <PusatMediaSub isId={isId} />
            </Route>
          </Switch>
        </StyledContent>
      </StyledBody>
    </>
  );
};

export default PusatMedia;
